let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ert18")).then(() => parcelRequire('b6eed'));